import React from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'components/Modal';
import { useRmaItemController } from 'utils/hooks';

const StartRmaModal = ({ onClose, ...props }) => {
  const history = useHistory();
  const { resetRma } = useRmaItemController();

  const handleModalConfirmation = () => {
    resetRma();

    history.push('/cases/new/search');
    onClose();
  };

  return (
    <Modal
      title="Start RMA"
      content="Any unsaved data will be lost. Are you sure you want to proceed?"
      flag="Warning"
      onConfirmation={handleModalConfirmation}
      onDismiss={onClose}
      onCancel={onClose}
      {...props}
    />
  );
};

export { StartRmaModal };
